/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/usersMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Users. */
var Users = /** @class */function () {
  /**
   * Create a Users.
   * @param {LabServicesClientContext} client Reference to the service client.
   */
  function Users(client) {
    this.client = client;
  }
  Users.prototype.listByLab = function (resourceGroupName, labName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      options: options
    }, listByLabOperationSpec, callback);
  };
  Users.prototype.get = function (resourceGroupName, labName, userName, options, callback) {
    return this.client.sendOperationRequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      userName: userName,
      options: options
    }, getOperationSpec, callback);
  };
  /**
   * Operation to create or update a lab user.
   * @summary Create or update a lab user.
   * @param body The request body.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<Models.UsersCreateOrUpdateResponse>
   */
  Users.prototype.createOrUpdate = function (body, resourceGroupName, labName, userName, options) {
    return this.beginCreateOrUpdate(body, resourceGroupName, labName, userName, options).then(function (lroPoller) {
      return lroPoller.pollUntilFinished();
    });
  };
  /**
   * Operation to update a lab user.
   * @summary Update a lab user.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<Models.UsersUpdateResponse>
   */
  Users.prototype.update = function (resourceGroupName, labName, userName, options) {
    return this.beginUpdate(resourceGroupName, labName, userName, options).then(function (lroPoller) {
      return lroPoller.pollUntilFinished();
    });
  };
  /**
   * Operation to delete a user resource.
   * @summary Deletes a user resource.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  Users.prototype.deleteMethod = function (resourceGroupName, labName, userName, options) {
    return this.beginDeleteMethod(resourceGroupName, labName, userName, options).then(function (lroPoller) {
      return lroPoller.pollUntilFinished();
    });
  };
  /**
   * Operation to invite a user to a lab.
   * @summary Invite a user to a lab.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRest.RestResponse>
   */
  Users.prototype.invite = function (resourceGroupName, labName, userName, options) {
    return this.beginInvite(resourceGroupName, labName, userName, options).then(function (lroPoller) {
      return lroPoller.pollUntilFinished();
    });
  };
  /**
   * Operation to create or update a lab user.
   * @summary Create or update a lab user.
   * @param body The request body.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRestAzure.LROPoller>
   */
  Users.prototype.beginCreateOrUpdate = function (body, resourceGroupName, labName, userName, options) {
    return this.client.sendLRORequest({
      body: body,
      resourceGroupName: resourceGroupName,
      labName: labName,
      userName: userName,
      options: options
    }, beginCreateOrUpdateOperationSpec, options);
  };
  /**
   * Operation to update a lab user.
   * @summary Update a lab user.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRestAzure.LROPoller>
   */
  Users.prototype.beginUpdate = function (resourceGroupName, labName, userName, options) {
    return this.client.sendLRORequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      userName: userName,
      options: options
    }, beginUpdateOperationSpec, options);
  };
  /**
   * Operation to delete a user resource.
   * @summary Deletes a user resource.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRestAzure.LROPoller>
   */
  Users.prototype.beginDeleteMethod = function (resourceGroupName, labName, userName, options) {
    return this.client.sendLRORequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      userName: userName,
      options: options
    }, beginDeleteMethodOperationSpec, options);
  };
  /**
   * Operation to invite a user to a lab.
   * @summary Invite a user to a lab.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param labName The name of the lab that uniquely identifies it within containing lab plan. Used
   * in resource URIs.
   * @param userName The name of the user that uniquely identifies it within containing lab. Used in
   * resource URIs.
   * @param [options] The optional parameters
   * @returns Promise<msRestAzure.LROPoller>
   */
  Users.prototype.beginInvite = function (resourceGroupName, labName, userName, options) {
    return this.client.sendLRORequest({
      resourceGroupName: resourceGroupName,
      labName: labName,
      userName: userName,
      options: options
    }, beginInviteOperationSpec, options);
  };
  Users.prototype.listByLabNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listByLabNextOperationSpec, callback);
  };
  return Users;
}();
export { Users };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listByLabOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName],
  queryParameters: [Parameters.apiVersion, Parameters.filter],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedUsers
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var getOperationSpec = {
  httpMethod: "GET",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users/{userName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.userName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.User
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var beginCreateOrUpdateOperationSpec = {
  httpMethod: "PUT",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users/{userName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.userName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: "body",
    mapper: __assign(__assign({}, Mappers.User), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.User
    },
    201: {
      bodyMapper: Mappers.User
    },
    202: {
      bodyMapper: Mappers.User
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var beginUpdateOperationSpec = {
  httpMethod: "PATCH",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users/{userName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.userName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: {
      additionalUsageQuota: ["options", "additionalUsageQuota"]
    },
    mapper: __assign(__assign({}, Mappers.UserUpdate), {
      required: true
    })
  },
  responses: {
    200: {
      bodyMapper: Mappers.User
    },
    202: {
      bodyMapper: Mappers.User
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var beginDeleteMethodOperationSpec = {
  httpMethod: "DELETE",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users/{userName}",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.userName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {},
    202: {},
    204: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var beginInviteOperationSpec = {
  httpMethod: "POST",
  path: "subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.LabServices/labs/{labName}/users/{userName}/invite",
  urlParameters: [Parameters.subscriptionId, Parameters.resourceGroupName, Parameters.labName, Parameters.userName],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  requestBody: {
    parameterPath: {
      text: ["options", "text"]
    },
    mapper: __assign(__assign({}, Mappers.InviteBody), {
      required: true
    })
  },
  responses: {
    200: {},
    202: {},
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listByLabNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://management.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedUsers
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};